// Fire-and-forget cleaner for expired ticket holds.
// Safe to run repeatedly; it only touches already-expired tickets.
import { collection, query, where, getDocs, doc, updateDoc, serverTimestamp, arrayRemove } from "firebase/firestore";
import { db } from "../../firebase";

export async function releaseExpiredHoldsForAgent(agentUid) {
    if (!agentUid) return;
    const now = Date.now();

    // fetch expired holds for this agent
    const q = query(
        collection(db, "tickets"),
        where("agentUid", "==", agentUid),
        where("status", "in", ["agent_approved", "payment_submitted"]) // requires composite index in some projects; if it errors, split into two queries
    );

    try {
        const snap = await getDocs(q);
        const batch = [];
        for (const d of snap.docs) {
            const t = d.data();
            const exp = t.paymentExpireAt?.toDate?.()?.getTime?.() || new Date(t.paymentExpireAt || 0).getTime();
            if (!exp || exp > now) continue;

            // mark ticket expired
            await updateDoc(doc(db, "tickets", d.id), {
                status: "expired",
                expiredAt: serverTimestamp(),
            });

            // release numbers from the card
            const nums = Array.isArray(t.numbers) ? t.numbers : [];
            if (nums.length) {
                await updateDoc(doc(db, "cards", t.cardId), {
                    locked: arrayRemove(...nums),
                });
            }
        }
    } catch (e) {
        // If the "in" query complains about index, you can do two queries:
        // status == "agent_approved" and status == "payment_submitted" separately.
        console.error("releaseExpiredHoldsForAgent error", e);
    }
}
